import {
	Component,
	OnInit,
	OnDestroy,
	ViewChild,
	ViewContainerRef,
	ComponentFactoryResolver,
	ComponentRef,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { ModalService, ModalConfig } from 'src/app/core/services/modal.service';

@Component({
	selector: 'app-modal-outlet',
	templateUrl: './modal-outlet.component.html',
	styleUrls: ['./modal-outlet.component.scss'],
})
export class ModalOutletComponent implements OnInit, OnDestroy {
	isOpen = false;
	currentConfig: ModalConfig | null = null;

	@ViewChild('modalContent', { read: ViewContainerRef, static: false })
	private container: ViewContainerRef;

	private componentRef: ComponentRef<any> | null = null;
	private sub: Subscription;

	constructor(
		private modalService: ModalService,
		private resolver: ComponentFactoryResolver,
	) {}

	ngOnInit() {
		this.sub = this.modalService.modal$.subscribe(config => {
			if (config) {
				this.isOpen = true;
				this.currentConfig = config;
				setTimeout(() => this.renderComponent(config));
			} else {
				this.isOpen = false;
				this.currentConfig = null;
				this.destroyComponent();
			}
		});
	}

	ngOnDestroy() {
		this.sub?.unsubscribe();
		this.destroyComponent();
	}

	close() {
		this.modalService.close();
	}

	private renderComponent(config: ModalConfig) {
		if (!this.container) return;
		this.destroyComponent();
		const factory = this.resolver.resolveComponentFactory(config.component);
		this.componentRef = this.container.createComponent(factory);
		if (config.props) {
			Object.assign(this.componentRef.instance, config.props);
		}
	}

	private destroyComponent() {
		if (this.componentRef) {
			this.componentRef.destroy();
			this.componentRef = null;
		}
	}
}
